<template 
>
   <v-layout wrap
      justify-center
               :style="cssVars"
   >
      <!--v-flex xs12 md6 lg4-->
      <v-flex :class="isSimulation ? 'xs12' : 'xs12 md6 lg4'">
         <center style="padding: 0 20px;">
            <v-date-picker
               class="booking-by-days-picker"
               no-title
               v-model="selectedDate"
               :event-color="date => date[9] % 2 ? 'red' : 'yellow'"
               :events="functionEvents"
               :picker-date.sync="pickerDate"
               @change="handleSelectDate"
               style="width: 100%"
               :locale="locale"
               :min="min"
               elevation="0"
               first-day-of-week="1"
              :loading="loading"
            />
            <categories-selector 
               :dtouchWorkspace="dtouchWorkspace"
               :content="content" 
               :locale="locale"
               :onChange="handleChangeCategories"
            />
            <place-selector 
               :dtouchWorkspace="dtouchWorkspace"
               :content="content" 
               :locale="locale"
               :onChange="handleChangePlaces"
            />
         </center>
      </v-flex>
      <!--v-flex xs12 md6 lg8 style="padding: 0 20px;"-->
      <v-flex  :class="isSimulation ? 'xs12': 'xs12 md6 lg8'" style="padding: 0 20px;">
         <v-layout wrap v-show="!loading">
            <v-flex 
                :class="isSimulation ? 'xs12' : 'xs12 md6 lg4'" 
               v-for="(item, index) of selectedActivities"
               :key="index"
               style="padding: 0 10px;"
            >
               <activities 
                  :activity="item"
                  :locale="locale"
                  :content="content"
                  :config="config"
                  :autoExpand="selectedActivities.length ===1"
               />
            </v-flex>
         </v-layout>
      </v-flex>
   </v-layout>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import utils from '@/services/utils'
import constants from '@/constants'
import Activities from './Activities'
import CategoriesSelector from './CategoriesSelector'
import PlaceSelector from './PlaceSelector'
export default {
   components: {
      Activities,
      CategoriesSelector,
      PlaceSelector,
   },
   props: {
      locale: {
         type: String,
         required: true,
      },
      content: {
         type: Object,
         required: true,
      },
      config: {
         type: Object,
         required: true,
      },
   },
   data: () => ({
      loading: false,
      selectedDate: null,
      pickerDate: null,
      arrayEvents: [],
      events: null,
      selectedEvents: null,
      selectedActivities: null,
      selectedCategories: [],
      selectedPlaces: [],
      categories: null,
   }),
   computed: {
      ...mapState('app', ['dtouchWorkspace']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      min () {
         return new Date().toISOString().split('T').shift()
      },
      cssVars () {
         return {
            '--time-bg-color': this.config.BGColor,
         }
      },
   },
   watch: {
      pickerDate (v) {
         this.handleGetEvents(v)
      },
   },
   mounted () {
      this.handleGetCategories()
      /*
      this.arrayEvents = [...Array(6)].map(() => {
         const day = Math.floor(Math.random() * 30)
         const d = new Date()
         d.setDate(day)
         return d.toISOString().substr(0, 10)
      })
      */
   },
   methods: {
      handleGetCategories () {
         this.categories = null
         const url = `${window.location.protocol}//${process.env.VUE_APP_API_URL_DTOUCH}/v1/public/cm/${this.dtouchWorkspace}/categories/`
         axios.get(url)
            .then((response) => {
               //console.log('response', response)
               if (!response || !response.data) return
               //this.categories = response.data.filter(x => x.WorkspaceID === this.content.BookingActWorkspaceID).map(item => {
               this.categories = response.data.filter(x => !this.content.BookingActWorkspaceID || x.WorkspaceID === this.content.BookingActWorkspaceID).map(item => {
                  item.Color = item.Color ? item.Color : '#000000'
                  return item
               })
            })
            .catch((error) => {
               console.log(error)
            })
            .then(() => {
               this.loading = false
            })
      },
      handleChangeCategories (v) {
         this.selectedCategories = v
         this.getActivitiesBySelectedEvents(this.selectedEvents)
      },
      handleChangePlaces (v) {
         this.selectedPlaces = v
         this.getActivitiesBySelectedEvents(this.selectedEvents)
      },
      handleGetEvents (v) {
         this.loading = true
         const [year, month] = v.split('-')
         const body = {
            year, 
            month
         }
         const url = `${window.location.protocol}//${process.env.VUE_APP_API_URL_DTOUCH}/v1/public/cm/${this.dtouchWorkspace}/events-month${this.content.BookingActWorkspaceID ? '/'.concat(this.content.BookingActWorkspaceID) : ''}`
         axios.post(url, body)
            .then((response) => {
               if (this.content.BookingActActivityID) {
                  // filter by activityID
                  response.data = response.data.filter(x => x.ActivityID === this.content.BookingActActivityID)
               }
               this.arrayEvents = response.data.map(item => item.Date.split('T').shift())
               this.events = response.data
                    .map(item => {
                      if(this.categories) item.CategoryName = this.categories.filter(x => x.ID === item.CategoryID).map(i => i.Name ? JSON.parse(i.Name) : null).shift() 
                      return item
                    })

               // selected now
               this.selectedDate = new Date().toISOString().split('T').shift()
               this.handleSelectDate()
            })
            .catch((error) => {
               console.log(error)
            })
            .then(() => {
               this.loading = false
            })
      },
      functionEvents (date) {
         if (this.arrayEvents.indexOf(date) >= 0) return [this.content.BookingActTimeColor]
/*
         const [,, day] = date.split('-')
         if ([12, 17, 28].includes(parseInt(day, 10))) return true
         if ([1, 19, 22].includes(parseInt(day, 10))) return ['red', 'green']
         return false
         */
      },
      handleSelectDate () {
         this.selectedEvents = this.events ? this.events.filter(x => x.Date.split('T').shift() === this.selectedDate) : null
         this.getActivitiesBySelectedEvents(this.selectedEvents)
      },
      getActivitiesBySelectedEvents (v) {
         this.selectedActivities = null
         //this.selectedActivities = [...new Set(v.map(item => {return { ActivityID: item.ActivityID, ActivityName: item.ActivityName }}))]
         if (!v) return
        const unique = v.sort((a, b) => { return a.Time - b.Time })
                        .map(item => item.ActivityID)
                        .filter((value, index, self) => self.indexOf(value) === index)
         
         if (unique.length === 0) return 

         const result = unique.map(item => {
            const aux = v.filter(x => x.ActivityID === item).shift()
        let link = null
        if (aux && aux.Link && aux.Link.length > 0) {
          link = {
            Name: aux.LinkName,
            URL: aux.Link
          }
        }

            const cat = this.categories ? this.categories.filter(x => x.ID === aux.CategoryID).shift() : null

            return {
               ID: aux.ActivityID,
               Name: aux.ActivityName,
               Subtitle: aux.ActivitySubtitle,
               AllowReservations: aux.AllowReservations,
               Description: aux.ActivityDescription,
               Image: aux.ActivityImage,
               ForceFirst: aux.ForceFirst,
               ForceLast: aux.ForceLast,
               CategoryID: aux.CategoryID,
               CategoryName: aux.CategoryName,
               CategoryColor: cat && cat.Color ? cat.Color : '#000000',
               PlaceID: aux.PlaceID,
              Place: aux.Place,
              Link: link,
               MeetingPointID: aux.MeetingPointID,
               Events: v.filter(x => x.ActivityID === item).sort((a, b) => a.Time - b.Time).map(item => {
                  item.startTime = item.Time
                  item.endTime = item.Time + item.Duration
                  item.sTime = utils.convertTime(item.Time)
                  item.type = 'contentmanager'
                  item.Source = 'contentmanager'
                  return item
               })
            }
         })
         .filter(x => !this.selectedCategories || this.selectedCategories.length === 0 || this.selectedCategories.indexOf(x.CategoryID) >= 0)
         .filter(x => !this.selectedPlaces || this.selectedPlaces.length === 0 || this.selectedPlaces.indexOf(x.PlaceID) >= 0)

         this.selectedActivities = []
         this.selectedActivities.push(...result.filter(x => x.ForceFirst))
         this.selectedActivities.push(...result.filter(x => !x.ForceFirst && !x.ForceLast))
         this.selectedActivities.push(...result.filter(x => x.ForceLast))

      },
   },
}
</script>
<style scoped>
.v-btn__content {
   z-index: 1;
}
.v-date-picker-table__events .yellow {
   height: 34px;
   width: 34px;
   margin-top: -19px;
   margin-left: -2px;
   border-radius: 4px;
   background-color: var(--time-bg-color) !important;
}
.v-application .yellow {
   height: 34px;
   width: 34px;
   margin-top: -19px;
   margin-left: -2px;
   border-radius: 4px;
   background-color: var(--time-bg-color) !important;
}
               .booking-by-days-picker {
   /*
   background-color: blue !important;
   transition-property: none !important;
   transition: none !important;
   outline: none !important;
   border-width: thin !important;*/
   box-shadow: none;
               }
</style>

